// Configure regeneratorRuntime first, so we don't error out
import './runtimeConfig'

// polyfills
import 'babel-polyfill'
import 'core-js/features/promise'

import React from 'react'
import ReactDOM from 'react-dom'

import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { unregister } from './registerServiceWorker'

import App from './components/App'

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn:
      'https://7d632bb3bf70415fb6b07fe29da3d795@o194799.ingest.sentry.io/5661682',
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.NODE_ENV,
  })
}

ReactDOM.render(<App />, document.getElementById('root'))

unregister()
